import { RelationshipProperty } from "../../property-types";
import {
  DynamicFilter,
  DynamicFilterOperator,
  DynamicFilterOpts,
} from "../DynamicFilter";

export class RelationshipManyFilter extends DynamicFilter {
  public operatorLabelsMap = {
    equals: "includes",
  };

  public disabledOperators: DynamicFilterOperator[] = [
    "notEquals",
    "lessThan",
    "greaterThan",
    "contains",
    "notContains",
  ];

  constructor(opts: DynamicFilterOpts) {
    super(opts);

    if (!this.property.isHydrated) {
    }
  }

  public getValueAsync(): Promise<any> {
    return (this.property as RelationshipProperty).hydrate().then(() => {
      return this.value;
    });
  }
}
